export default "<li class=\"search-suggest-keyword-item\">\n  <a>\n    <span><b></b></span\n  ></a>\n</li>\n"